/** Same as ENV_SLUG used in startup.sh */
export type EnvSlug =
  | 'dev'
  | 'dev-gcp-us'
  | 'test' // for unit tests and storybook
  | 'qe'
  | 'qe-gcp-us'
  | 'live-staging'
  | 'live'
  | 'live-eu'
  | 'live-gcp-sa'
  | 'live-gcp-la'
  | 'live-gcp-sy'
  | 'live-gcp-yz';

export type TracingEnv = EnvSlug | 'local';

export type RunningEnv = EnvSlug | 'local' | 'storybook';

/** Configuration values of the environment the application is running in. */
export type EnvConfig = Readonly<{
  apiHostname: string;
  browserExtensionIds: string[];
  enableTelemetry: boolean;
  enableUiTracking: boolean;
  environmentSlug: EnvSlug;
  launchDarklyId: string;
  remoteHostname?: string;
  siteStatusPageUrl?: string;
}>;

/** list of required keys in EnvConfig */
export const envConfigRequiredKeys = [
  'apiHostname',
  'browserExtensionIds',
  'enableTelemetry',
  'enableUiTracking',
  'environmentSlug',
  'launchDarklyId',
];

export const jestEnvConfig: EnvConfig = {
  apiHostname: '',
  browserExtensionIds: [''],
  enableTelemetry: false,
  enableUiTracking: false,
  environmentSlug: 'test',
  launchDarklyId: '',
};

export const storybookEnvConfig: EnvConfig = {
  apiHostname: 'api.dev.obsec.us',
  browserExtensionIds: [''],
  enableTelemetry: false,
  enableUiTracking: false,
  environmentSlug: 'dev',
  launchDarklyId: '',
};
